// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ss-z","tooltipWrapper":"ts-z","icon":"us-z","tooltip":"vs-z","content":"ws-z"};